function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.3125 1H4.625C3.66359 1 2.74156 1.3841 2.06174 2.0678C1.38192 2.75151 1 3.67881 1 4.64571V33.8114C1 34.7783 1.38192 35.7056 2.06174 36.3893C2.74156 37.073 3.66359 37.4571 4.625 37.4571H26.375C27.3364 37.4571 28.2584 37.073 28.9383 36.3893C29.6181 35.7056 30 34.7783 30 33.8114V13.76M17.3125 1L30 13.76M17.3125 1V13.76H30",
  stroke: "#999999",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 5,
  y: 20,
  width: 10,
  height: 3,
  fill: "#F3F3F3",
  stroke: "#999999",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 5,
  y: 26,
  width: 15,
  height: 3,
  fill: "#F3F3F3",
  stroke: "#999999",
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 17,
  y: 20,
  width: 8,
  height: 3,
  fill: "#F3F3F3",
  stroke: "#999999",
  strokeWidth: 2
});

var SvgDocument2 = function SvgDocument2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 39,
    viewBox: "0 0 31 39",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocument2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/document2.2924fdab.svg";
export { ForwardRef as ReactComponent };